import { render } from "./BasePanel.vue?vue&type=template&id=dd27cc8c&ts=true"
import script from "./BasePanel.vue?vue&type=script&lang=ts"
export * from "./BasePanel.vue?vue&type=script&lang=ts"

import "./BasePanel.vue?vue&type=style&index=0&id=dd27cc8c&lang=scss"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__